<template>
	<div class="app-sale" id="app_sale">
		<h3 class="app-sale-title">
			{{ getConstants('EAGLE_LANDING_SALE_TITLE') }}
		</h3>
		<div class="app-sale-description">
			{{ getConstants('EAGLE_LANDING_SALE_SUBTITLE') }}
		</div>
		<div class="app-sale-content dp-f">
			<EagleProTap />
			<EagleAdvanceTap />
		</div>
	</div>
</template>
<script>
import EagleProTap from './EagleProTap'
import EagleAdvanceTap from './EagleAdvanceTap'
export default {
	components: {
		EagleProTap,
		EagleAdvanceTap,
	},
}
</script>

<style lang="scss" scoped>
.app-sale {
	margin-top: 80px;
	padding-top: 200px;
	padding-bottom: 40px;
	.app-sale-title {
		text-align: center;
		font-size: 28px;
		line-height: 32px;
		color: #107ffc;
	}
	.app-sale-description {
		margin: 24px auto 0;
		padding: 0 20px;
		max-width: 560px;
		line-height: 24px;
		font-size: 16px;
		text-align: center;
		color: #6d6d6d;
	}
	.app-sale-content {
		justify-content: center;
		flex-wrap: wrap;
	}
}
</style>
